import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Index from '../views/Index.vue'
import Customer from '../views/custom/index.vue'
import Dingdan from '../views/dingdan/index.vue'
import axios from "../axios";
import store from "../store"

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		children: [
			{
				path: '/index',
				name: 'Index',
				meta: {
					title: "首页"
				},
				component: Index
			},
			{
				path: '/device',
				name: 'Device',
				meta: {
					title: "设备列表"
				},
				component: () => import('@/views/device/device.vue')
			},
			{
				path: '/customer',
				name: 'Customer',
				meta: {
					title: "客户列表"
				},
				component: Customer
			},	
			{
				path: '/ding',
				name: 'Dingdan',
				meta: {
					title: "订单列表"
				},
				component: Dingdan
			},	
			{
				path: '/userCenter',
				name: 'UserCenter',
				meta: {
					title: "个人中心"
				},
				component: () => import('@/views/UserCenter.vue')
			},
		]
	},

	{
		path: '/login',
		name: 'Login',
		component: () => import('@/views/Login.vue')
	}
]

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  // console.log(location)
  return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

const router = new VueRouter({
	// mode: 'history',
	// base: process.env.BASE_URL,
	base: '/platform/',
	routes
})

router.beforeEach((to, from, next) => {
	let token = localStorage.getItem("token")
	if (to.path == '/login') {
		next()
	} else if (!token) {
		next({path: '/login'})
	}
	next()
})


// 导航转成路由
const menuToRoute = (menu) => {

	if (!menu.component) {
		return null
	}

	let route = {
		name: menu.name,
		path: menu.path,
		meta: {
			icon: menu.icon,
			title: menu.title
		}
	}
	route.component = () => import('@/views/' + menu.component +'.vue')

	return route
}

export default router 